export default {
  install(Vue) {
    Vue.prototype.$randomKey = function() {
      return Math.random()
        .toString(36)
        .substring(7);
    };
  },
};
